const gjcDivCardElement = function (key, value) {
  const isKeyClickable =
    key === 'cel' ||
    key === 'rrogat' ||
    key === 'plateArray' ||
    key === 'family_id';
  const clickableElementClass = isKeyClickable ? 'gjc-clickable-element' : '';

  const displayValue =
    isKeyClickable && key !== 'family_id' ? 'CLICK TO VIEW' : value;
  const addClass = isKeyClickable ? `shouldQueryRrogat--${key}` : '';

  const element = `
        <div class="card-footer ${addClass}">
            <small class="text-muted" style="display: flex;justify-content: space-between;"">
            <span class="gjc-data-key">${key}:</span>
            <span style="font-weight: bold;"
             class="gjc-data-value ${clickableElementClass}">${displayValue}</span>
            </small>
        </div>
    `;
  return element;
};

const gjcDivCardHeader = function (key = '', value, type) {
  const element = `
            <div class="card-horizontal">
            <div class="card-body">
                <h4 class="card-title "">
                <span class="gjc-data-key">${key}</span>
                <span class="gjc-data-value movements__type--${type}">${value}</span>
                </h4>
            </div>
        </div>
        `;
  return element;
};

const cardViewContainer = function (content) {
  const container = `
    <div class="movements__row">        
    <div class="card fill-parent-width">
        ${content}
    </div>
    </div>
    `;
  return container;
};

const openModal = function (containerModal, modalHtml) {
  containerModal.insertAdjacentHTML('beforebegin', modalHtml);
  const btnCloseModal = document.querySelector('.btn--close-gjcmodal');
  const overlay = document.querySelector('.overlay');

  btnCloseModal.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
};

const closeModal = function () {
  const overlay = document.querySelector('.overlay');
  const modal = document.querySelector('.gjcmodal');
  modal.remove();
  overlay.remove();
};

const buildLabelInput = function (key, value) {
  const element = `
    <label style="padding:0;font-size:1rem">${key}: </label>
    <label readonly style="padding:0;font-size:1rem;">${value}</label>
    `;
  return element;
};

const createNextPageButtons = function (arraySize) {
  let listOfPageButtons = [];
  if (arraySize > 1) {
    //Create next page buttons.
    for (let value = 1; value <= arraySize; value++) {
      const btnClass = `gjcpagebtn${value}`;
      const buttonElement = `
      <button class="${btnClass}" class="btn--next-page-gjcmodal">Page ${value}</button>
      `;

      listOfPageButtons.push(buttonElement);
    }
  }
  return listOfPageButtons.join('');
};

const buildModalContainerHtml = function (pageButtons, content, title) {
  const container = `
  <div class="gjcmodal">
  <button class="btn--close-gjcmodal">&times;</button>
  <h3 class="gjcmodal__header">${title}</h3>
  ${pageButtons}
  <div class="gjc-row-content">
  ${content}
  </div>
  </div>
  <div class="overlay"></div>
  `;
  return container;
};

const buildModalInput = function (
  modalTitle,
  placeholder1,
  placeholder2 = null
) {
  const input1 = `<input type="text" placeholder="${placeholder1}" class="form__input form__input--to" />`;
  const input2 = placeholder2
    ? `<input type="text" placeholder="${placeholder2}" class="form__input form__input--amount" />`
    : '';

  const container = `
  <div class="gjcmodal">
  <button class="btn--close-gjcmodal">&times;</button>
  <div class="operation operation--transfer">
  <h2>${modalTitle}</h2>
  <form class="form form--transfer">
    ${input1}
    ${input2}
    <button class="form__btn form__btn--transfer gjc-modal-form-btn">&rarr;</button>
  </form>
  </div>
  </div>
  <div class="overlay"></div>
  `;
  return container;
};

const buildModalError = function (errorMessage, modalTitle) {
  const container = `
  <div class="gjcmodal">
  <button class="btn--close-gjcmodal">&times;</button>
  <div class="operation operation--transfer">
  <h2>${modalTitle}</h2>
  <form class="form form--transfer">
  <div style="font-size: 1.5rem;text-align: center;"> ${errorMessage} </div>
  </form>
  </div>
  </div>
  <div class="overlay"></div>
  `;
  return container;
};

const showModalError = function (
  containerModal,
  errorMessage,
  modalTitle = 'Error'
) {
  const html = buildModalError(errorMessage, modalTitle);
  openModal(containerModal, html);
};

const showModalSearchByName = function (containerModal) {
  const html = buildModalInput('Search By Name', 'first name', 'last name');
  openModal(containerModal, html);
};

const showModalSearchInputOne = function (containerModal, title, placeholder) {
  const html = buildModalInput(title, placeholder);
  openModal(containerModal, html);
};

const openRrogatModal = function (
  containerModal,
  rrogatJson,
  title = 'Rrogat:'
) {
  const arraySize = rrogatJson.length;

  let listOfHtmlContentsToDisplay = [];

  rrogatJson.forEach(function (gjcObject, i) {
    let body = [];
    for (const [key, value] of Object.entries(gjcObject)) {
      body.push(buildLabelInput(key, value));
    }

    listOfHtmlContentsToDisplay.push(`    
    <div class="gjcmodal__form" style="gap:0.3rem;">
    ${body.join('')}
    </div>
    `);
  });

  const html = buildModalContainerHtml(
    createNextPageButtons(arraySize),
    listOfHtmlContentsToDisplay[0],
    title
  );

  openModal(containerModal, html);

  if (arraySize > 1) {
    //Create next page buttons.
    for (let value = 1; value <= arraySize; value++) {
      const btnId = `gjcpagebtn${value}`;
      document.querySelector(`.${btnId}`).onclick = function () {
        console.log('btn clicked', btnId);
        document.querySelector('.gjc-row-content').innerHTML = `${
          listOfHtmlContentsToDisplay[value - 1]
        }`;
      };
    }
  }
};

export {
  gjcDivCardElement,
  gjcDivCardHeader,
  cardViewContainer,
  closeModal,
  openRrogatModal,
  showModalSearchByName,
  showModalSearchInputOne,
  showModalError,
};
